import { Component, input } from '@angular/core';

@Component({
  selector: 'app-table-loading',
  standalone: true,
  host: {
    class: 'kt-datatable-overlay bg-background/70 pointer-events-none',
    role: 'status',
    'aria-live': 'polite',
    'aria-atomic': 'true',
  },
  templateUrl: './table-loading.component.html',
})
export class TableLoadingComponent {
  readonly message = input('Loading...');
}
